import { IconTrashDelete } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconBin: FC<IconProps> = props => (
  <SvgIcon {...props} component={IconTrashDelete} />
)

export default IconBin
